import type * as api from '@owl-nest/api-client/latest'
import { lens } from '@owl-nest/config'
import { Lang } from '@owl-nest/api-client/latest'

type HelpModalConfiguration = {
  helpUrls: {
    [lang in Lang]: string
  }
  videos: {
    modalNewBackofficeLaunch: {
      placeholder: {
        [lang in Lang]: {
          x1: string
          x2: string
          x3: string
        }
      }
      version: {
        [lang in Lang]: string
      }
    }
  }
}

type UFE = {
  locale: string
  user: api.AuthenticatedUser & {
    is_authenticated: boolean
    nb_projects: number
    project_list_url?: string
    settings_url?: string
    transactions_url: string
  }
}

type ENVIRONMENT = {
  UFE: UFE
}

const windowLens = lens<ENVIRONMENT>()

const global =
  typeof process !== 'undefined'
    ? {
        CURRENCIES: process.env.CURRENCIES ? JSON.parse(process.env.CURRENCIES) : undefined,
        UFE: process.env.UFE ? JSON.parse(process.env.UFE) : undefined,
      }
    : window

export const USER = windowLens.get('UFE').get('user').value(global)
export const USER_LOCALE = windowLens.get('UFE').get('locale').value(global) as api.Lang
